import { useQuery } from '@tanstack/react-query'
import { wollemAgentApi } from '../api'

export const useListChats = (enabled = true) =>
  useQuery({
    queryKey: ['agent-chats'],
    queryFn: wollemAgentApi.listChats,
    enabled,
  })
